import { useEffect, useState } from 'react';

/** true enquanto a media query casa (ex.: '(min-width: 1280px)' para o computador). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return matches;
}

export const TABLET = '(min-width: 768px)';
export const DESKTOP = '(min-width: 1280px)';
